export const GOOGLE_ANALYTICS_4 = 'GOOGLE_ANALYTICS_4';
export const INITIALIZE_LOCATION_PIXEL = 'INITIALIZE_LOCATION_PIXEL';
export const SET_REFERRAL_SOURCE = 'SET_REFERRAL_SOURCE';
export const SET_UTM_CAMPAIGN = 'SET_UTM_CAMPAIGN';
export const FACEBOOK_ADD_TO_CART_EVENT = 'AddToCart';
export const PIXEL_INIT_OPTIONS = { autoConfig: true, debug: false };
